import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AppInsightsLogEntry } from '../../models/dead-letter-logs.model';

@Component({
    selector: 'app-dead-letter-log-section',
    templateUrl: './dead-letter-log-section.component.html',
    styleUrls: ['./dead-letter-log-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DeadLetterLogSectionComponent {
  @Input() logsEntries: AppInsightsLogEntry[] = [];
  @Input() logsLoading = false;
  @Input() logsError = false;
}
